function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material import
import { useTheme } from "@mui/material/styles";
// @limitless
import { useTranslation } from "@limitless/common/hooks";
const getButtonStyle = (theme, variant, disabled) => {
  var _theme$palette$button, _theme$overrides, _theme$overrides$MuiB;
  let variantButtonStyle;
  const disableButtonStyle = {
    cursor: "default",
    pointerEvents: "none",
    boxShadow: "none",
    backgroundColor: "transparent"
  };
  let buttonMainColor = theme.palette.primary.main;
  let buttonHoverColor = `${theme.palette.primary.main}40`;
  let buttonContrastColour = theme.palette.primary.contrastText;
  if ((_theme$palette$button = theme.palette.buttons) !== null && _theme$palette$button !== void 0 && _theme$palette$button.submit) {
    buttonMainColor = theme.palette.buttons.submit.backgroundColor;
    buttonContrastColour = theme.palette.buttons.submit.textColor;
    buttonHoverColor = theme.palette.buttons.submit.hoverBackgroundColor;
  }
  if (variant === "contained") {
    variantButtonStyle = {
      color: buttonContrastColour,
      backgroundColor: buttonMainColor,
      //doesn't work
      ":hover": {
        color: buttonContrastColour,
        backgroundColor: buttonHoverColor
      }
    };
    if (disabled) {
      variantButtonStyle = {
        ...disableButtonStyle,
        color: theme.palette.action.disabled,
        backgroundColor: theme.palette.action.disabledBackground
      };
    }
  }
  if (variant === "text") {
    variantButtonStyle = {
      backgroundColor: "transparent",
      color: buttonMainColor
    };
    if (disabled) {
      variantButtonStyle = {
        ...disableButtonStyle,
        color: theme.palette.action.disabled
      };
    }
  }
  if (variant === "outlined") {
    variantButtonStyle = {
      border: `1px solid ${buttonMainColor}`,
      color: theme.palette.primary.main,
      backgroundColor: "transparent"
    };
    if (disabled) {
      variantButtonStyle = {
        ...disableButtonStyle,
        color: theme.palette.action.disabled,
        border: `1px solid ${theme.palette.action.disabled}`
      };
    }
  }
  return {
    outline: 0,
    border: 0,
    margin: 0,
    cursor: "pointer",
    lineHeight: 1.75,
    borderRadius: 30,
    fontWeight: 500,
    fontSize: 14,
    fontFamily: "'Roboto', Helvetica, Arial, sans-serif",
    boxShadow: "none",
    minWidth: 64,
    height: 36.5,
    padding: "6px 16px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    verticalAlign: "middle",
    position: "relative",
    ...variantButtonStyle,
    ...((_theme$overrides = theme.overrides) === null || _theme$overrides === void 0 ? void 0 : (_theme$overrides$MuiB = _theme$overrides.MuiButton) === null || _theme$overrides$MuiB === void 0 ? void 0 : _theme$overrides$MuiB.root)
  };
};
const CustomerButton = ({
  children,
  id = "cutomer-button-default-id",
  variant = "contained",
  disabled,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const defaultButtonStyle = React.useMemo(() => getButtonStyle(theme, variant, disabled), [variant, disabled]);
  return /*#__PURE__*/React.createElement("button", _extends({
    id: id
  }, rest, {
    style: {
      ...defaultButtonStyle,
      ...rest.style
    }
  }), typeof children === "string" ? t(children) : children);
};
CustomerButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.string,
  variant: PropTypes.string,
  disabled: PropTypes.bool
};
export default CustomerButton;